"use client";

import React from "react";
import { cn } from "@/lib/utils";

interface ChatMessage {
    id: string;
    sender: string;
    time: string;
    message: string | React.ReactNode;
    isSelf?: boolean;
    avatarColor?: string;
}

const messages: ChatMessage[] = [
    {
        id: "1",
        sender: "Maja Roth",
        time: "15:05",
        message: "I can’t wait to get out of this meeting, such a waste of time!",
        avatarColor: "bg-pink-500"
    },
    {
        id: "2",
        sender: "John Smart",
        time: "15:06",
        message: "Agree! I don’t understand how this can be a job that one would be doing voluntarily.",
        avatarColor: "bg-blue-500"
    },
    {
        id: "3",
        sender: "Susanne Pelz",
        time: "15:07",
        message: "I find this interesting to be honest.",
        avatarColor: "bg-green-500"
    },
    {
        id: "4",
        sender: "Kim Kleine",
        time: "15:07",
        message: (
            <span>
                WTF Susanne? <br />
                tell me that you wouldn’t prefer coding over this <br />
                What’s wrong with you?
            </span>
        ),
        avatarColor: "bg-red-500"
    },
    {
        id: "5",
        sender: "Susanne Pelz",
        time: "15:48",
        message: "Yes, I love coding.",
        avatarColor: "bg-green-500"
    }
];

export function TeamChat() {
    return (
        <div className="w-full max-w-lg mx-auto bg-card border rounded-xl overflow-hidden shadow-sm flex flex-col h-[500px]">
            {/* Header */}
            <div className="bg-muted/40 p-4 border-b flex items-center justify-between">
                <div className="font-semibold flex items-center gap-2">
                    <div className="h-2 w-2 rounded-full bg-green-500 animate-pulse"></div>
                    Team Channel
                </div>
                <div className="text-xs text-muted-foreground">5 online</div>
            </div>

            {/* Messages Area */}
            <div className="flex-1 overflow-y-auto p-4 space-y-4 bg-muted/10">
                {messages.map((msg) => (
                    <div key={msg.id} className="flex gap-3">
                        <div className={cn(
                            "h-8 w-8 rounded-full flex items-center justify-center text-xs font-bold text-white shrink-0",
                            msg.avatarColor || "bg-gray-500"
                        )}>
                            {msg.sender.split(' ').map(n => n[0]).join('')}
                        </div>
                        <div className="flex flex-col gap-1 max-w-[80%]">
                            <div className="flex items-baseline gap-2">
                                <span className="text-sm font-semibold">{msg.sender}</span>
                                <span className="text-[10px] text-muted-foreground">{msg.time}</span>
                            </div>
                            <div className="bg-background border rounded-lg p-3 text-sm shadow-sm">
                                {msg.message}
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Input Area (Mock) */}
            <div className="p-3 border-t bg-background">
                <div className="flex items-center gap-2 bg-muted rounded-md px-3 py-2 text-muted-foreground text-sm cursor-not-allowed opacity-50">
                    <span>Message Team Channel...</span>
                </div>
            </div>
        </div>
    );
}
